import { yupResolver } from '@hookform/resolvers/yup';
import { FieldValues, useForm, UseFormProps, UseFormReturn } from 'react-hook-form';
import { AnyObjectSchema, ValidateOptions } from 'yup';

/**
 * A shorthand hook for using react-hook-form useForm together with yup validation schema
 * @param yupSchema yup validations schema
 * @param validationOptions yup validation options
 * @param formOptions form options
 */
export function useFormWithYup<
    TFieldValues extends FieldValues = FieldValues,
    TContext extends Record<string, unknown> = Record<string, unknown>,
>(
    yupSchema?: AnyObjectSchema,
    validationOptions: ValidateOptions<AnyObjectSchema> = {
        abortEarly: false,
    },
    formOptions: UseFormProps<TFieldValues, TContext> = {},
): UseFormReturn<TFieldValues, TContext> {
    if (yupSchema) {
        if (!formOptions.mode) {
            // default to validate on leaving the field. can be overriden.
            formOptions.mode = 'onBlur';
        }
        formOptions.resolver = yupResolver(yupSchema, validationOptions);
    }

    return useForm(formOptions);
}
